import axios from 'axios';
import Cookie from 'cookies-js';
import toastr from 'toastr';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  ROBO_ADVISORY_SUCCESS,
  ROBO_ADVISORY_ERROR,
  ROBO_ADVISORY_LOADING,
  ROBO_ADVISORY_ERROR_DELETE
} from '../types';

const roboAdvisorySuccess = advisory => ({
  type: ROBO_ADVISORY_SUCCESS,
  advisory
});

const roboAdvisoryLoading = () => ({
  type: ROBO_ADVISORY_LOADING
});

const roboAdvisoryError = error => ({
  type: ROBO_ADVISORY_ERROR,
  error
});

export const deleteRoboAdvisoryError = () => ({
  type: ROBO_ADVISORY_ERROR_DELETE
});

const roboAdvisory = advisoryDetails => (dispatch) => {
  dispatch(roboAdvisoryLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(
    `${config.apiUrl}${routes.ROBOADVISORY}`, advisoryDetails, {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(roboAdvisorySuccess(data));
      toastr.success(data.responseMessage);
    } else {
      dispatch(roboAdvisoryError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(roboAdvisoryLoading());
    dispatch(roboAdvisoryError(data.responseMessage));
    throw error;
  });
};

export default roboAdvisory;
